import { Box, Stack, Tab, Tabs, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { InviteStatus } from 'src/@types/userOrg';
import { orgSwitcherTabs, orgTabLabels } from './constants';

type OrgSwitcherTabsProps = {
  counts: Record<InviteStatus, number>;
  selectedTab: InviteStatus;
  onSelectedTabChange: (value: InviteStatus) => void;
  tabs?: InviteStatus[];
};

export default function OrgSwitcherTabs({
  counts,
  selectedTab,
  onSelectedTabChange,
  tabs = orgSwitcherTabs,
}: OrgSwitcherTabsProps) {
  return (
    <Tabs
      value={selectedTab}
      onChange={(_, value: InviteStatus) => onSelectedTabChange(value)}
      variant="fullWidth"
      sx={{
        px: 2,
        borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
        '& .MuiTabs-indicator': {
          height: 3,
        },
        '& .MuiTab-root': {
          alignItems: 'flex-start',
          textTransform: 'none',
          minHeight: 56,
          py: 1.5,
        },
      }}
    >
      {tabs.map((tab) => {
        const isSelected = selectedTab === tab;

        return (
          <Tab
            key={tab}
            value={tab}
            sx={{ alignItems: 'flex-start' }}
            label={
              <Stack direction="row" spacing={1} alignItems="center" sx={{ minHeight: 36 }}>
                <Typography
                  sx={{
                    fontSize: 16,
                    fontWeight: 600,
                    color: isSelected ? 'text.primary' : 'text.secondary',
                  }}
                >
                  {orgTabLabels[tab]}
                </Typography>
                {counts[tab] > 0 && (
                  <Box
                    sx={{
                      minWidth: 32,
                      height: 32,
                      px: 1,
                      borderRadius: 0.75,
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      bgcolor: isSelected
                        ? (theme) => alpha(theme.palette.primary.main, 0.12)
                        : (theme) => alpha(theme.palette.grey[500], 0.12),
                      color: isSelected ? 'primary.main' : 'text.secondary',
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 13,
                        fontWeight: (theme) => theme.typography.fontWeightBold,
                        lineHeight: 1,
                      }}
                    >
                      {counts[tab]}
                    </Typography>
                  </Box>
                )}
              </Stack>
            }
          />
        );
      })}
    </Tabs>
  );
}
